import { useGetInsuranceCarriers } from '@features/insuranceCarriers/hooks/useInsuranceCarriers';
import { SelectPlus } from 'Components/SelectPlus';
import { getErrorMessage } from '@/shared/utils/errors/getErrorMessage';

export const SelectInsuranceCarrier = ({ mode = 'single', ...selectProps }) => {
  const { data = [], isFetching, isError, error } = useGetInsuranceCarriers();

  const isSingleMode = mode === 'single';
  const placeholder = `Seleccionar aseguradora${isSingleMode ? '' : 's'}`;

  const options = data.map(record => ({
    value: record.id,
    label: record.name,
    record,
  }));

  return (
    <SelectPlus
      mode={mode}
      placeholder={placeholder}
      loading={isFetching}
      options={options}
      popupMatchSelectWidth // Hace que el menú desplegable tenga siempre el mismo ancho que el componente Select
      error={isError}
      errorMessage={getErrorMessage(error)}
      {...selectProps}
    />
  );
};